import { apiClient, unwrap } from './client';
import type { ApiResponse } from '@/types/api';

export interface PlayStoreIframeTokenDto {
  token: string;
  iframeUrl: string;
  resourceName: string;
  enterpriseId: number;
  expiresAt: string;
}

export interface RegisterApprovedAppRequest {
  enterpriseId: number;
  packageName: string;
  isPrivate: boolean;
}

/**
 * Cliente para los endpoints de Managed Google Play iframe.
 * Doc: https://developers.google.com/android/management/managed-google-play-iframe
 */
export const playStoreApi = {
  /**
   * Pide al backend un token para embebir el iframe de Managed Google Play.
   * @param enterpriseId nuestro ID interno de la empresa
   * @param features lista de features a habilitar. Default: todas.
   *   Valores: PLAY_SEARCH, PRIVATE_APPS, WEB_APPS, STORE_BUILDER
   */
  getIframeToken(
    enterpriseId: number,
    features?: string[],
  ): Promise<PlayStoreIframeTokenDto> {
    const params: Record<string, string | number> = { enterpriseId };
    if (features && features.length > 0) params.features = features.join(',');
    return unwrap(
      apiClient.get<ApiResponse<PlayStoreIframeTokenDto>>('/apps/play-iframe-token', { params }),
    );
  },

  /**
   * Registra en el catalogo local una app que el usuario aprobo via iframe.
   * Lo invoca el handler del postMessage cuando el iframe nos avisa.
   */
  registerApproved(request: RegisterApprovedAppRequest): Promise<number> {
    return unwrap(
      apiClient.post<ApiResponse<number>>('/apps/register-approved', request),
    );
  },
};
